import * as React from 'react'

import { Wrapper } from './style'

const Scroller: React.FC<{ children?: React.ReactNode; className?: string }> = ({ children, className }) => (
  <Wrapper className={className}>{children}</Wrapper>
)

export default Scroller
